export const PUBLIC_SITE_ORIGIN = "https://tennis-log.com";

export function buildConnectedMatchInviteUrl(token: string): string {
  const url = new URL("/invite", PUBLIC_SITE_ORIGIN);
  url.hash = `t=${encodeURIComponent(token)}`;
  return url.toString();
}
